/* eslint-disable @typescript-eslint/no-use-before-define */
import { Close } from "@mui/icons-material";
import { IconButton, InputAdornment, Stack, TextField } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useEffect, useState } from "react";

export interface FormDialogProps {
  title: string;
  isOpen: boolean;
  idCase: any;
  text: any;
  close: () => void;
  save: (newValue: any) => void;
}

const ChangeTextTableDialog = (props: FormDialogProps) => {
  const [text, setText] = useState<string>("");
  useEffect(() => {
    setText(props.text);
  }, [props.text]);
  return (
    <Dialog open={props.isOpen}>
      <DialogTitle>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          {props.title}
          <IconButton
            color="error"
            onClick={() => {
              props.close();
            }}
          >
            <Close />
          </IconButton>
        </Stack>
      </DialogTitle>

      <DialogContent sx={{ minWidth: 370 }}>
        <TextField
          hiddenLabel
          autoFocus
          variant="filled"
          value={text}
          onChange={(event) => setText(event.target.value)}
          inputProps={{ maxLength: 30 }}
          InputProps={{
            endAdornment: text.trim() && (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => {
                    setText("");
                  }}
                  size="small"
                >
                  <Close />
                </IconButton>
              </InputAdornment>
            ),
          }}
          fullWidth
        />
      </DialogContent>

      <DialogActions>
        <Button
          onClick={() => {
            props.save(text);
            setText("");
          }}
          color="success"
        >
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChangeTextTableDialog;
